export const MASK = {
  MSISDN_WITH_PREFIX: ['+', '2', '3', '4', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  MSISDN_WITHOUT_PREFIX: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  DATE: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/]
};

export const defaultEmptyValueKey = '_';

export const isMaskCompleted = (value: string, maskEmptyValueKey: string = defaultEmptyValueKey): boolean =>
  !value.includes(maskEmptyValueKey);
